<ion-grid
  fixed="true"
  class="ion-padding-vertical-0"
>
  <ion-row>
    <ion-col size="12">
      @for (action of footerActions(); track $index) {
        <ion-button
          (click)="action.action()"
          color="primary"
          expand="block"
          fill="solid"
          size="large"
          [disabled]="!!action.disabled"
        >
          <ion-icon
            slot="start"
            aria-hidden="true"
            [src]="action.icon"
          ></ion-icon>
          {{ action.label }}
        </ion-button>
      }
    </ion-col>
  </ion-row>
</ion-grid>
